import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';

import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import { BlackHeading1, Black, LogeButtonSlim } from '../GeneralStyle'
import { ProfileBox } from './ProfileStyle'

import ReactGA from "react-ga";

import BlogPost from './BlackboardBlog/BlogPost'
import BlogPostEditor from './BlackboardBlog/BlogPostEditor'
import offerImg from '../../images/offer.jpeg'
@inject('blogStore', 'userStore')
@observer
class Blackboard extends Component {

  trackGaBooking() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Zum Buchungskalender'
    });
  }

  trackGaResidence() {
    ReactGA.event({
      category: 'Booking',
      action: 'Navigate',
      label: 'Zum Residence Buchungskalender'
    });
  }

  componentWillMount() {
    this.props.blogStore.getActiveOffers()
  }

  render() {


    const { isActiveOffers, activeOffers } = this.props.blogStore
    const { userRole, isResidenceRole } = this.props.userStore

    let blogPosts = []
    if (isActiveOffers) {
      activeOffers.reverse().map((blogPost, key) => {
        return blogPosts.push(
          <div key={key}>
            <BlogPost
              title={blogPost.title}
              imageId={blogPost.image}
              createdAt={blogPost.createdAt}
              text={blogPost.text}
              objectId={blogPost.objectId}
              isHighlighted={blogPost.isHighlighted} />
          </div>
        )
      })
    }

    return (
      <div style={{ maxWidth: 1400 }}>
        <ProfileBox style={{ padding: 0 }}>

          <Row className={'row-eq-height-resp'}>
            <Col xs={12} md={12} style={{ marginRight: 0 }}>

              <Row style={{ maxWidth: 1000, paddingTop: 45, paddingLeft: 45, margin: 'auto' }} className={"blackboard-heading"}>
                <BlackHeading1 className={"blackboard-heading"} style={{ textAlign: "left" }}>WILLKOMMEN IM EXKLUSIVEN THE LOGE ANGEBOTS BEREICH. </BlackHeading1>
              </Row>

              <Row className={'row-eq-height-resp blackboard-heading'}>

                <Col style={{ paddingLeft: 45, marginTop: 25 }} xs={12} md={12} lg={8}>
                  <div className={'aligner'} style={{ height: '100%', paddingBottom: 45 }}>
                    <Black style={{ fontSize: 14, paddingTop: 25 }}>
                      Hier haben nur The Loge Mitglieder Zugang und dieser Angebots Bereich steht exklusiv für Sonderangebote zur Verfügung.
                      Viel Erfolg bei Eurem Business!</Black>
                  </div>
                </Col>
              </Row>

            </Col>
            <Col xsHidden md={4} style={{ padding: 0, background: `url(${offerImg})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}>
            </Col>
          </Row>

          <Row>{((userRole === "admin") || (userRole === "theLoge"))
            ? <BlogPostEditor blogCategory={"offer"}/> : null}</Row> {/** toDo  - create dynamic functionality*/}
        </ProfileBox>
        <ProfileBox style={{ border: "1px solid rgba(0, 0, 0, 0.15)", borderRadius: 0 }}>
          {blogPosts}
        </ProfileBox>
      </div>
    )
  }
}
Blackboard.propTypes = {
  blogStore: MobxPropTypes.observableObject,
  userStore: MobxPropTypes.observableObject,
};
export default Blackboard;



// WEBPACK FOOTER //
// /src/components/internal/Offers.js